import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {

	return {
		popularContentWrapper: {
			display        : "flex",
			flexWrap       : "wrap",
			gap            : "2rem",
			justifyContent : "space-evenly",

			[rooterMediaQuery.tablet]: {
				gap: "2rem 0rem"
			}
		},
		heading: {
			fontSize   : "1.5rem",
			fontWeight : "500"
		},
		viewAll: {
			display      : "flex",
			alignSelf    : "center",
			fontSize     : "1.4rem",
			fontWeight   : "500",
			color        : "#126bd5",
			marginBottom : "1rem",
			cursor       : "pointer"
		}
	};
} );
